"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Availability = void 0;
const native_base_1 = require("native-base");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const atome_1 = require("../../../atome");
const Breakpoints_1 = require("../../../../helper/Breakpoints");
const organisms_1 = require("../../../organisms");
const AbortFUPModal_1 = require("./AbortFUPModal");
const UtilityFunctions_1 = require("../../../../helper/UtilityFunctions");
const hooks_1 = require("../../../../store/hooks");
const reducers_1 = require("../../../../store/reducers");
const lodash_1 = __importDefault(require("lodash"));
const GlobalStyles_1 = require("../../../../helper/GlobalStyles");
//@ts-ignore
function Availability(props) {
    const { navigation, setCurrentPage, showFUPRModal, setShowFUPRModal } = props;
    const prescriptionInfo = (0, hooks_1.useAppSelector)(reducers_1.selectPrescriptionInfo);
    const [prescriptionTemp, setPrescriptionTemp] = (0, react_1.useState)(prescriptionInfo);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const [isButtonDisabled, setIsButtonDisabled] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const areAllFieldsFalseOrUndefined = !prescriptionTemp?.medicationAvailable;
        areAllFieldsFalseOrUndefined
            ? setIsButtonDisabled(true)
            : setIsButtonDisabled(false);
    }, [prescriptionTemp]);
    const handleBackButton = () => {
        let reducerType = {
            type: '[UPDATE]',
            payload: {
                followUpPrescriptionsIndex: 8,
            },
        };
        setCurrentPage(reducerType);
    };
    const preparePreparationQuestionArrayForNextStepReplaceMedicine = () => {
        const newPrepQuestionArray = lodash_1.default.cloneDeep(prescriptionTemp.preparationQuestion);
        const fieldsAlreadyExist = newPrepQuestionArray.some((item) => (0, UtilityFunctions_1.isInObject)(item, 'changeThisPreparation') &&
            (0, UtilityFunctions_1.isInObject)(item, 'exchangeWithThisPreparation'));
        if (fieldsAlreadyExist) {
            return;
        }
        prescriptionTemp.preparationQuestion.forEach((item, index) => {
            newPrepQuestionArray[index].changeThisPreparation = false;
            newPrepQuestionArray[index].exchangeWithThisPreparation = '';
        });
        dispatch((0, reducers_1.setPrescriptionInfo)({
            ...prescriptionTemp,
            preparationQuestion: newPrepQuestionArray,
        }));
    };
    const deleteNextStepReplaceMedicineFields = () => {
        const newPreparationQuestionArray = [];
        prescriptionTemp?.preparationQuestion?.forEach((item) => {
            let newObj = lodash_1.default.cloneDeep(item);
            delete newObj.changeThisPreparation;
            delete newObj.exchangeWithThisPreparation;
            newPreparationQuestionArray.push(newObj);
        });
        dispatch((0, reducers_1.setPrescriptionInfo)({
            ...prescriptionTemp,
            preparationQuestion: newPreparationQuestionArray,
        }));
    };
    const next = () => {
        // dispatch(setPrescriptionInfo(prescriptionTemp));
        prescriptionTemp?.medicationAvailable === 'changeMedication'
            ? preparePreparationQuestionArrayForNextStepReplaceMedicine()
            : deleteNextStepReplaceMedicineFields();
        let reducerType = {
            type: '[UPDATE]',
            payload: {
                followUpPrescriptionsIndex: prescriptionTemp?.medicationAvailable === 'changeMedication'
                    ? 10
                    : 11,
            },
        };
        setCurrentPage(reducerType);
    };
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(native_base_1.ScrollView, { bgColor: "#fff", h: "100%", w: "100%" },
            Breakpoints_1.isDesktop && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            react_1.default.createElement(native_base_1.VStack, { space: 5, alignItems: 'center', style: GlobalStyles_1.globalStyles.mobileToWebContainer },
                react_1.default.createElement(native_base_1.Center, { w: "100%", mt: "20" },
                    react_1.default.createElement(native_base_1.Text, { fontSize: "2xl", textAlign: "center", fontWeight: "bold", color: "#3db384" }, "Lieferbarkeit")),
                react_1.default.createElement(native_base_1.Center, { w: "90%", mt: "3", mb: "4" },
                    react_1.default.createElement(native_base_1.Text, { textAlign: "center" }, "Haben Sie die Lieferbarkeit Ihrer Medikation bei Ihrer Apotheke gepr\u00FCft?")),
                react_1.default.createElement(native_base_1.VStack, { w: "90%" },
                    react_1.default.createElement(atome_1.RadioButton, { label: "Ja, alle Pr\u00E4parate sind verf\u00FCgbar", isSelected: prescriptionTemp?.medicationAvailable === 'yes', onPress: () => {
                            setPrescriptionTemp({
                                ...prescriptionTemp,
                                medicationAvailable: 'yes',
                            });
                        } }),
                    react_1.default.createElement(atome_1.RadioButton, { label: "Ich ben\u00F6tige ein Austauschpr\u00E4parat", isSelected: prescriptionTemp?.medicationAvailable === 'changeMedication', onPress: () => {
                            setPrescriptionTemp({
                                ...prescriptionTemp,
                                medicationAvailable: 'changeMedication',
                            });
                        } }),
                    react_1.default.createElement(atome_1.RadioButton, { label: "Nein, ich konnte die Lieferbarkeit nicht pr\u00FCfen", isSelected: prescriptionTemp?.medicationAvailable === 'no', onPress: () => {
                            setPrescriptionTemp({
                                ...prescriptionTemp,
                                medicationAvailable: 'no',
                            });
                        } })),
                prescriptionTemp?.medicationAvailable === 'no' && (react_1.default.createElement(native_base_1.Center, { my: "10", px: "5" },
                    react_1.default.createElement(native_base_1.Text, { color: "#979797" },
                        react_1.default.createElement(native_base_1.Text, { bold: true }, "Hinweis:"),
                        " Sollte Ihre Medikation nicht lieferbar sein, kann es zu Verz\u00F6gerungen kommen. Ihr Arzt muss moglicherweise ein Austauschpraparat festlegen."))),
                react_1.default.createElement(native_base_1.HStack, { space: [4, 10], justifyContent: "center", pb: "250" },
                    react_1.default.createElement(native_base_1.Button, { mt: "12", w: "40%", backgroundColor: '#fff', borderRadius: "3xl", _text: { color: '#3db384', fontWeight: 'bold', underline: true }, onPress: handleBackButton }, "Zur\u00FCck"),
                    react_1.default.createElement(native_base_1.Button, { disabled: isButtonDisabled, mt: "12", w: ['40%', '80%'], backgroundColor: isButtonDisabled ? '#3db38475' : '#3db384', borderRadius: "3xl", _text: { color: '#fff', fontWeight: 'bold' }, onPress: next }, "Weiter"))),
            react_1.default.createElement(AbortFUPModal_1.AbortFUPModal, { navigation: navigation, setCurrentPage: setCurrentPage, showFUPRModal: showFUPRModal, setShowFUPRModal: setShowFUPRModal }))));
}
exports.Availability = Availability;
